<template>
    <div class="mt-3">
        <div class="card">
            <div class="card-header">
                Jadwal Operasi
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <button class="btn btn-sm btn-primary" @click="createJadwal">Tambah</button>
                    </div>
                </div>

                <div v-if="is_create">
                    <hr>
                    <h5 class="card-title">{{ form_title }}</h5>

                    <div class="row mt-3">
                        <div class="col">
                            <div class="row mt-3">
                                <div class="col-sm-4 text-right col-form-label">No Registrasi</div>
                                <div class="col">
                                    <input type="text" class="form-control" v-model="data_jadwal.kodebooking" @change="getRegistrasi">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-4 text-right col-form-label">Tanggal Operasi</div>
                                <div class="col">
                                    <input type="date" class="form-control" v-model="data_jadwal.tanggaloperasi">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-4 text-right col-form-label">Jenis Tindakan</div>
                                <div class="col">
                                    <input type="text" class="form-control" v-model="data_jadwal.jenistindakan">
                                </div>
                            </div>
                            <div v-if="data_jadwal.action == 'edit'" class="row mt-3">
                                <div class="col-sm-4 text-right col-form-label">Status</div>
                                <div class="col">
                                    <select v-model="data_jadwal.status" class="form-control">
                                        <option value="0">Belum Terlaksana</option>
                                        <option value="1">Sudah Terlaksana</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row mt-3">
                                <div class="col-sm-4 text-right col-form-label">No Peserta</div>
                                <div class="col">
                                    <input type="text" class="form-control" v-model="data_jadwal.nomorpeserta">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-4 text-right col-form-label">Poli</div>
                                <div class="col">
                                    <select2 class="form-input" v-model="data_jadwal.kodepoli" :options="option_poli" @change="getDokter"></select2>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-4 text-right col-form-label">Dokter</div>
                                <div class="col">
                                    <select2 class="form-input" v-model="data_jadwal.kodedokter" :options="option_dokter"></select2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <button class="btn btn-sm btn-primary" @click="simpanJadwal">Simpan</button>
                        <button class="btn btn-sm btn-danger" @click="cancelCreate">Batal</button>
                    </div>
                </div>

                <div>
                    <hr>
                    <h5 class="card-title">Daftar Jadwal Operasi</h5>

                    <div class="mt-3">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">id</th>
                                    <th scope="col">Kode Booking</th>
                                    <th scope="col">Tanggal Operasi</th>
                                    <th scope="col">Jenis Tindakan</th>
                                    <th scope="col">Kode Poli</th>
                                    <th scope="col">Nama Poli</th>
                                    <th scope="col">Kode Dokter</th>
                                    <th scope="col">Nama Dokter</th>
                                    <th scope="col">Terlaksana</th>
                                    <th scope="col">Nomor Peserta</th>
                                    <th scope="col">Aksi</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(jo, idx) in jadwal_operasi" :key="idx">
                                    <td scope="row">{{ jo.id }}</td>
                                    <td>{{ jo.kode_booking }}</td>
                                    <td>{{ jo.tanggal_operasi }}</td>
                                    <td>{{ jo.jenis_tindakan }}</td>
                                    <td>{{ jo.kode_poli_bpjs }}</td>
                                    <td>{{ jo.nama_poli }}</td>
                                    <td>{{ jo.kode_dpjp }}</td>
                                    <td>{{ jo.nama_dokter }}</td>
                                    <td>{{ jo.terlaksana == 0 ? 'Belum' : 'Sudah' }}</td>
                                    <td>{{ jo.nomor_peserta }}</td>
                                    <td>
                                        <button class="btn btn-outline-primary btn-sm" @click="editJadwalOperasi(jo)">Edit</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <b-pagination-nav
                        v-if="jadwal_operasi.length > 0"
                        class="mt-3"
                        v-model="page"
                        :link-gen="linkGen"
                        :number-of-pages="number_of_page"
                        prev-text="Prev"
                        next-text="Next"
                        use-router
                        align="center"
                    >
                    </b-pagination-nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Select2 from 'v-select2-component'

export default {
    components: {
        Select2
    },
    watch: {
        '$route' (to, from) {
            this.page = to.query.page
            this.getJadwal()
        }
    },
    data() {
        return {
            is_create: false,
            form_title: 'Buat Jadwal Operasi',
            option_poli: [{id: 0, text: '---- Pilih Poli ----'}],
            option_dokter: [{id: 0, text: '---- Pilih Dokter ----'}],
            data_jadwal: {
                action: 'create',
                id: 0,
                kodebooking: null,
                tanggaloperasi: null,
                jenistindakan: null,
                status: 0,
                nomorpeserta: null,
                kodepoli: 0,
                kodedokter: 0,
            },
            jadwal_operasi: [],
            page: 1,
            per_page: 10,
            number_of_page: 0,
        }
    },
    created() {
        this.getPoli()
        this.getJadwal()
    },
    methods: {
        createJadwal() {
            this.form_title = 'Buat Jadwal Operasi'
            this.is_create = true
            this.data_jadwal = {
                action: 'create',
                id: 0,
                kodebooking: null,
                tanggaloperasi: null,
                jenistindakan: null,
                status: 0,
                nomorpeserta: null,
                kodepoli: 0,
                kodedokter: 0,
            }
        },
        getPoli() {
            this.$isLoading(true)
            let uri = '/api/get-poli'

            this.axios.get(uri).then(response => {
                this.option_poli = [{id: 0, text: '---- Pilih Poli ----'}]

                let poli_data = response.data.poli
                poli_data.forEach(data => {
                    if (data.KdBPJS) {
                        this.option_poli.push({id: data.KDPoli, text: data.KdBPJS + ' - ' + data.NMPoli})
                    }
                });

                this.$isLoading(false)
            })
        },
        getDokter() {
            this.$isLoading(true)
            let uri = '/api/get-dokter?kd_poli=' + this.data_jadwal.kodepoli

            this.axios.get(uri).then(response => {
                this.option_dokter = [{id: 0, text: '---- Pilih Dokter ----'}]

                let dokter_data = response.data.dokter
                dokter_data.forEach(data => {
                    if (data.KdDPJP) {
                        this.option_dokter.push({id: data.KdDoc, text: data.KdDPJP + ' - ' + data.NmDoc})
                    }
                });

                this.$isLoading(false)
            })
        },
        getRegistrasi() {
            this.$isLoading(true)
            let uri = '/api/get-registrasi-operasi?regno=' + this.data_jadwal.kodebooking

            this.axios.get(uri).then(response => {
                this.$isLoading(true)
                if (response.data.status == 'success') {
                    let registrasi = response.data.registrasi

                    this.data_jadwal.nomorpeserta = registrasi.NoPeserta
                    this.data_jadwal.kodepoli = registrasi.KdPoli
                    this.getDokter()
                    this.data_jadwal.kodedokter = registrasi.KdDoc

                    this.$isLoading(false)
                } else {
                    alert(response.data.message)

                    this.$isLoading(false)
                }
            })
        },
        simpanJadwal() {
            this.$isLoading(true)
            let uri = '/api/jadwal-operasi'

            this.axios.post(uri, {data_jadwal: this.data_jadwal}).then(response => {
                if (response.data.status == 'success') {
                    this.getJadwal()
                    this.is_create = false
                    this.$isLoading(false)
                } else {
                    alert(response.data.message)
                    this.$isLoading(false)
                }
            })
        },
        cancelCreate() {
            this.is_create = false
            this.data_jadwal = {
                kodebooking: null,
                tanggaloperasi: null,
                jenistindakan: null,
                nomorpeserta: null,
                kodepoli: 0,
                kodedokter: 0,
            }
        },
        getJadwal() {
            this.$isLoading(true)
            let query_page = this.page ? '&page=' + this.page : ''
            let uri = '/api/jadwal-operasi?page=' + query_page + '&per_page=' + this.per_page

            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    this.jadwal_operasi = response.data.jadwal_operasi.data
                    this.number_of_page = response.data.jadwal_operasi.last_page
                } else {
                    alert('Jadwal tidak ditemukan!')
                }
                this.$isLoading(false)
            })
        },
        editJadwalOperasi(jo) {
            this.form_title = 'Edit Jadwal Operasi ' + jo.kode_booking
            this.is_create = true
            this.data_jadwal = {
                action: 'edit',
                id: jo.id,
                kodebooking: jo.kode_booking,
                tanggaloperasi: jo.tanggal_operasi,
                jenistindakan: jo.jenis_tindakan,
                status: jo.terlaksana,
                nomorpeserta: jo.nomor_peserta,
                kodepoli: jo.kode_poli,
                kodedokter: jo.kode_dokter,
            }
            this.getDokter()
        },
        linkGen(pageNum) {
            return pageNum === 1 ? '?' : `?page=${pageNum}`
        }
    }
}
</script>
